import { jsx } from "react/jsx-runtime";
import "react";
import { Carousel } from "../../Carousel/index.js";
import { FilterChip } from "../../FilterChip/index.js";
function FilterChipBar({ filterChipData, handleFilterChipClick, selectedFilterChipData }) {
    return /*#__PURE__*/ jsx("div", {
        className: "p-2",
        children: /*#__PURE__*/ jsx(Carousel, {
            carouselId: "autocomplete-filter-bar",
            dragFree: true,
            slideWidth: "auto",
            slides: filterChipData.map((item)=>({
                    childrenNodes: /*#__PURE__*/ jsx(FilterChip, {
                        label: item.name,
                        onClick: (e, selected)=>{
                            e?.stopPropagation();
                            e?.preventDefault();
                            handleFilterChipClick(item, selected ?? false);
                        },
                        selected: selectedFilterChipData.has(`${item.filterType}_${item.code}_${item.name}`)
                    }),
                    id: item.code
                })),
            type: "content",
            slotClassNames: {
                containerClass: 'gap-1'
            }
        })
    });
}
export { FilterChipBar as default };
